export class DeliveryOptions {
    constructor(public emails: string[]
              , public exportTypes: number[]
              , public deliveryType: number
              , public rateTableId: number
              ) {
    }
}
